import SingleInput from "./SingleInput";
import { requirements } from "utils/constants";

import { useEffect, useState } from "react";
const CreatePasswordFields = ({ watch, errors, register }) => {
  const [passwordRequirements, setPasswordRequirements] =
    useState(requirements);
  const password = watch("password");
  // Trigger check requirements on password change
  useEffect(() => {
    setPasswordRequirements(checkPasswordRequirements(password));
  }, [password]);
  const checkPasswordRequirements = password => {
    const updatedRequirements = [...requirements];
    updatedRequirements.forEach(
      requirement => (requirement.status = requirement.validate(password))
    );

    return updatedRequirements;
  };

  return (
    <>
      <SingleInput
        label="Password"
        name={"password"}
        type="password"
        isNoFeedback={true}
        errors={errors}
        register={register}
        placeholder="Password"
      />

      <ul>
        {passwordRequirements.map((req, index) => (
          <li
            key={index}
            className={req.status ? "text-success" : "text-danger"}
          >
            {req.label}
          </li>
        ))}
      </ul>
      <SingleInput
        label="Confirm Password"
        name={"confirmPassword"}
        type="password"
        errors={errors}
        register={register}
        placeholder="Confirm Password"
      />
    </>
  );
};
export default CreatePasswordFields;
